import { lazy } from "react";
import { Navigate } from "react-router-dom";
import HomePage from "../views/Home/home.js";
import APS_Invoice from "../views/Invoices/APS_Invoice/APS_Invoice.js";
import NewInvoice from "../views/Invoices/NewInvoice/NewInvoice.js";
import ProcessInvoice from "../views/Invoices/ProcessInvoice/ProcessInvoice.js";
import LogisticsTeam from "../views/Invoices/LogisticsTeamInvoice/LogisticsTeam.js";
import TaxTeamDetail from "../views/Invoices/TaxTeam/TaxTeamDetail.js";
import TaxTeamPage from "../views/Invoices/TaxTeam/TaxTeam.js";
import BuyerInvoice from "../views/Invoices/BuyerInvoice/BuyerInvoice.js";
// import Roleapidata from "../views/Invoices/NewInvoice/Roleapidata.jsx";
import Addrole from "../views/RoleManagement/User/Addrole.jsx";
import AdminSettings from "../views/RoleManagement/User/AdminSetting.js";
import VendorFinancinglandingpage from "../views/VendorFinancing/VendorFinancinglandingpage.js";
import TreasuryReview from "../views/VendorFinancing/Treasury/TreasuryReview"
import PageNotFound from "../views/Invoices/NewInvoice/PageNotFound.js";
import ProtectedRoute from './ProtectedRoute.js'
import LoamInvoice from "../LoamApprover/LoamInvoice.js";
import Department from "../views/Invoices/DepartmentCoordinator/Department.js";
import DepartmentDetail from "../views/Invoices/DepartmentCoordinator/DepartmentDetail.js";
import LoamDetail from "../LoamApprover/LoamDetail.js";
import ProcessInvoiceDetail from "../views/Invoices/ProcessInvoice/ProcessInvoiceDetail.js";
import APSConfiguration from "../views/Generalconfiguration/APSConfiguration.js";
import PaymentReport from "../views/Invoices/PaymentReport/PaymentReport.js";
import AdminSetting from "../views/Invoices/AdminSetting/AdminSetting.js";
import LM_SSM_DHR from "../views/Invoices/HR_Invoices/LM_SSM_DHR.js";
import LM_SSM_DHRDetail from "../views/Invoices/HR_Invoices/LM_SSM_DHRDetail.js";
import VendorFinancing from "../views/VendorFinancing/VendorFinancing.js";
import VFInvoiceDetail from "../views/VendorFinancing/VFInvoiceDetail.js";
import NewInvoiceDetailPage from "../views/Invoices/NewInvoice/NewInvoiceDetailpage";
import APS_InvoiceDetailPage from "../views/Invoices/APS_Invoice/APS_InvoiceDetailPage.js";
import ViewOnlyDetailPage from "../views/Invoices/NewInvoice/viewOnlyDetailPage.js";
import VendorFinancingLc from "../views/VendorFinancingLc/vendorFinancingLc.js";
import NewLc from "../views/VendorFinancingLc/NewLc.js";
import BuyerDashboard from "../views/Reports/dashboard/BuyerDashboard.js";


import ChangeInvoiceUserLandingPage from "../views/changeInvoiceUser/changeInvoiceUserLandingPage.js";
import Reports from "../views/Reports/Reports.js";
import InvoiceStatus from "../views/Reports/InvoiceStatus.js";
import InvoicereturnToVender from "../views/Reports/InvoicereturnToVender.js";
import InvoicePendingReport from "../views/Reports/InvoicePendingReport.js";
import StatusInvoiceReport from "../views/Reports/StatusInvoiceReport.js";
import GetInvoicePaid from "../views/Reports/GetInvoicePaid.js";
import LongOutStandingReport from "../views/Reports/LongOutStandingReport.js";
import ApsReport from "../views/Reports/ApsReport.js";
import InvoicePaidAfterDue from "../views/Reports/InvoicePaidAfterDue.js";
import PoReport from "../views/Reports/PoReport.js";
import TaxByPass from "../views/Reports/TaxByPass.js";
import GRNVarianceReport from "../views/Reports/GRNVarianceReport.js";
import AdminDashboard from "../views/Reports/dashboard/AdminDashboard.js";
import PendingInvoice from "../views/Reports/PendingInvoice.js";
import TaxI2pToSap from "../views/Reports/TaxI2p_To_Sap.js";
import QueriesResponseTime from "../views/Reports/QueriesResponseTime.js";
import InvoiceReturnToPreProcessing from "../views/Reports/InvoiceReturnToPreProcessing.js";
import ReportAddUser from "../views/ReportsManagement/ReportAddUser.js";
import ReportAddRole from "../views/ReportsManagement/ReportAddRole.js";
import { element } from "prop-types";
import Signatories from "../views/Invoices/Components/Signatories/Signatories.js";
import VendorAccessLandingPage from "../views/VendorAccess/vendorAccessLandingPage.js";


/****Layouts*****/
const FullLayout = lazy(() => import("../layouts/FullLayout/FullLayout.js"));
/****End Layouts*****/

/*****Pages******/
const Dashboard1 = lazy(() => import("../views/dashboards/Dashboard1"));

/*****Tables******/
// const BasicTable = lazy(() => import("../views/Finance/GL Module/index"));
// const AddGLEntry = lazy(() => import("../views/Finance/GL Module/GLForm"));

// form elements
// const ExAutoComplete = lazy(() =>
// import("../views/FormElements/ExAutoComplete")
// );
// const ExButton = lazy(() => import("../views/FormElements/ExButton"));
// const ExCheckbox = lazy(() => import("../views/FormElements/ExCheckbox"));
// const ExRadio = lazy(() => import("../views/FormElements/ExRadio"));
// const ExSlider = lazy(() => import("../views/FormElements/ExSlider"));
// const ExSwitch = lazy(() => import("../views/FormElements/ExSwitch"));
// form layouts
// const FormLayouts = lazy(() => import("../views/FormLayouts/FormLayouts"));
// const ChartofAccount = lazy(() =>
// import("../views/Finance/ChartofAccounts/index")
// );
// const GLIquiryForm = lazy(() => import("../views/Finance/GLInquiry/index"));
// const ValidateEntry = lazy(() =>
// import("../views/Finance/GL Module/ValidateEntry")
// );
// const JournalReport = lazy(() =>
// import("../views/Finance/Reports/JournalReports")
// );
// const GeneralLedgerReport = lazy(() =>
// import("../views/Finance/Reports/GeneralLedgerReport")
// );
// const GeneralLedgerSummary = lazy(() =>
// import("../views/Finance/Reports/GeneralLedgerSummary")
// );
// const TrailBalance = lazy(() =>
//   import("../views/Finance/Reports/TrialBalance")
// );
// const PaymentAccountDetails = lazy(() =>
//   import("../views/Finance/Payment Account Deatils/Index.js")
// );
// const AddPaymentAccountDetails = lazy(() =>
//   import("../views/Finance/Payment Account Deatils/PaymentAcctDetailsForm.js")
// );
// const DespositVoucher = lazy(() =>
//   import("../views/Finance/DepositVoucher/index")
// );
// const PaymentVoucher = lazy(() =>
//   import("../views/Finance/PaymentVoucher/index")
// );
// const AddPaymentVoucher = lazy(() =>
//   import("../views/Finance/PaymentVoucher/PaymentVoucherForm")
// );
// const AddDespositVoucher = lazy(() =>
//   import("../views/Finance/DepositVoucher/DepositVoucherForm")
// );
const Adduser = lazy(() => import("../views/RoleManagement/User/Adduser.jsx"));
// const AddAccounts = lazy(() =>
//   import("../views/Finance/Configurations/AddAccounts")
// );
// const AddTax = lazy(() => import("../views/Finance/Configurations/AddTax"));

/*****Routes******/
const role_info = localStorage.getItem("persist:root");


const ThemeRoutes = [
  {
    path: "/",
    element: <FullLayout />,
    children: [
      { path: "*", element: <Navigate to="/home" /> },
      { path: "/", element: <Navigate to="/home" /> },
      // { path: "/", element: <Navigate to="/dashboard" /> },
      { path: "/home", exact: true, element: <HomePage /> },
      { path: "/newInvoice", exact: true, element: <NewInvoice /> },
      {path:"/NewInvoiceDetail", exact:true , element:<NewInvoiceDetailPage/>},
      { path: "/VFtreasury", exact: true, element:<VendorFinancing /> },
      { path: "/vendorfinancing", exact: true, element: <VendorFinancinglandingpage /> },
      { path: "/vendorfinancingLC", exact: true, element: <VendorFinancingLc /> },
      {path:"/newLc", exact :true , element: <NewLc />},
      { path: "/changeInvoiceUser", exact: true, element: <ChangeInvoiceUserLandingPage /> },

           { path: "/vendorAccess", exact: true, element: <VendorAccessLandingPage /> },

      // { path: "/vendorfinancing", exact: true, element: <ProtectedRoute><VendorFinancinglandingpage /> </ProtectedRoute> },
      { path: "/InvDetailPage", exact: true, element: <VFInvoiceDetail />  },
     
      { path: "/TreasuryReview", exact: true, element: <TreasuryReview /> },
      // Role Management
      { path: "/Adduser", element: <Adduser /> },
      { path: "/Addrole", element: <Addrole /> },
      { path: "/TaxConfig", element: <AdminSettings /> },
      // general configuration
      {path: "/APSConfiguration" , element: <APSConfiguration/>},
      // { path: "/Add", element: <Roleapidata /> },
      // invoices
      { path: "/invoice", element: < NewInvoice /> },
      { path: "/taxCheck", element: <TaxTeamPage /> },
      { path: "/processInvoice", element: <ProcessInvoice /> },
      { path: "/logisticsInvoice", element: <LogisticsTeam/>},
      { path: "/taxteamdetail", element: <TaxTeamDetail/>},
      { path: "/buyerInvoice", element: <BuyerInvoice/>},
      { path: "/prInitiatorInvoice", element: <BuyerInvoice/>},
      { path : "/LineManager", element: <LM_SSM_DHR/>},
      { path : "/SharedServices", element: <LM_SSM_DHR/>},
      { path : "/DirectorHR", element: <LM_SSM_DHR/>},
      {path : "/LineManagerDetail", element: <LM_SSM_DHRDetail/>},
      {path : "/SharedServicesDetail", element: <LM_SSM_DHRDetail/>},
      {path : "/DirectorHRDetail", element: <LM_SSM_DHRDetail/>},


      




      { path: "/loamApprover", element: <LoamInvoice /> },
      { path: "/APS_Invoice", element: <APS_Invoice /> },
      { path: "/APS_InvoiceDetailPage", element: <APS_InvoiceDetailPage /> },


      { path: "/dashboard", exact: true, element: <Dashboard1 /> },

      // Department & Reviwer Screen
      {path:"/departmentCoordinator", exact: true, element: <Department/>},
      {path:"/reviwerInvoice", exact: true, element: <Department/>},

      {path:"/departmentDetail", exact: true, element: <DepartmentDetail/>},
      {path:"/reviwerInvoiceDetail", exact: true, element: <DepartmentDetail/>},

      {path:"/loamDetail", exact: true, element: <LoamDetail/>},
      {path:"/processInvoiceDetail" , exact:true, element: <ProcessInvoiceDetail/>},
      {path:"/paymentReport",exact:true,element: <PaymentReport/>},
      {path:"/signatories",exact:true,element: <Signatories/>},
      { path: "/AdminSettings", element: <AdminSetting /> },
      {path : "/pageNotFound" , element : <PageNotFound/>},
      {path: "/viewOnlyPageDetail", element : <ViewOnlyDetailPage/>},

      


       //Code from Vendor
      { path: "/Reports", element: <Reports /> },
      { path: "/reportsusers", element: <ReportAddUser /> },
      { path: "/reports_role", element: <ReportAddRole /> },


      // { path: "/Add", element: <Roleapidata /> },
      { path: "/invoice", element: <NewInvoice /> },
      { path: "/taxCheck", element: <TaxTeamPage /> },
      { path: "/processInvoice", element: <ProcessInvoice /> },
      { path: "/logisticsInvoice", element: <LogisticsTeam /> },
      { path: "/taxteamdetail", element: <TaxTeamDetail /> },
      { path: "/buyerInvoice", element: <BuyerInvoice /> },
      { path: "/prInitiatorInvoice", element: <BuyerInvoice /> },
      { path: "/LineManager", element: <LM_SSM_DHR /> },
      { path: "/SharedServices", element: <LM_SSM_DHR /> },
      { path: "/DirectorHR", element: <LM_SSM_DHR /> },
      { path: "/LineManagerDetail", element: <LM_SSM_DHRDetail /> },
      { path: "/SharedServicesDetail", element: <LM_SSM_DHRDetail /> },
      { path: "/DirectorHRDetail", element: <LM_SSM_DHRDetail /> },
      { path: "/loamApprover", element: <LoamInvoice /> },
      { path: "/APS_Invoice", element: <APS_Invoice /> },
      { path: "/APS_InvoiceDetailPage", element: <APS_InvoiceDetailPage /> },
      { path: "/invoice_status", element: <InvoiceStatus /> },
      { path: "/status_report", element: <StatusInvoiceReport /> },
      { path: "/vender_pending", element: <InvoicePendingReport /> },
      { path: "/return_invoice", element: <InvoicereturnToVender /> },
      { path: "/getInvoice_paidOnTime", element: <GetInvoicePaid /> },
      { path: "/aps_report", element: <ApsReport /> },

      { path: "/return_to_reprocessing", element: <InvoiceReturnToPreProcessing /> },

      { path: "/getQuriesResponse", element: <QueriesResponseTime /> },
      { path: "/long_Outstanding", element: <LongOutStandingReport /> },
      { path: "/invoicepaid_afterdue", element: <InvoicePaidAfterDue /> },
      { path: "/po_compilance", element: <PoReport /> },
      { path: "/gettax", element: <TaxByPass /> },
      { path: "/grn_variance-report", element: <GRNVarianceReport /> },
      { path: "/dashboard", exact: true, element: <Dashboard1 /> },
      // Department & Reviwer Screen
      { path: "/departmentCoordinator", exact: true, element: <Department /> },
      { path: "/reviwerInvoice", exact: true, element: <Department /> },

      { path: "/departmentDetail", exact: true, element: <DepartmentDetail /> },
      {
        path: "/reviwerInvoiceDetail",
        exact: true,
        element: <DepartmentDetail />,
      },
      { path: "/loamDetail", exact: true, element: <LoamDetail /> },
      {
        path: "/processInvoiceDetail",
        exact: true,
        element: <ProcessInvoiceDetail />,
      },
      { path: "/paymentReport", exact: true, element: <PaymentReport /> },
      { path: "/signatories", exact: true, element: <Signatories /> },
      { path: "/AdminSettings", element: <AdminSetting /> },
      {path : "/pageNotFound" , element : <PageNotFound/>},
      {path: "/viewOnlyPageDetail", element : <ViewOnlyDetailPage/>},
      { path: "/admindashboard", element: <AdminDashboard /> },
      {path:"/buyerdashboard",element:<BuyerDashboard/>},
      { path: "/pending_invoices", element: <PendingInvoice/> },
      {path:"/i2p_to_sap", element:<TaxI2pToSap/> }
      //Vendor COde

      
      
      
      // { path: "/GLTable", element: <BasicTable /> },
      // { path: "/AddGLEntry", element: <AddGLEntry /> },
      // { path: "/ValidateEntry", element: <ValidateEntry /> },
      // { path: "/ChartofAccounts", element: <ChartofAccount /> },
      // { path: "/GLIquiry", element: <GLIquiryForm /> },
      // { path: "/JournalReport", element: <JournalReport /> },
      // { path: "/GeneralLedgerReport", element: <GeneralLedgerReport /> },
      // { path: "/GeneralLedgerSummary", element: <GeneralLedgerSummary /> },
      // { path: "/TrailBalance", element: <TrailBalance /> },
      // { path: "/PaymentAccountDetails", element: <PaymentAccountDetails /> },
      // {
      //   path: "/AddPaymentAccountDetails",
      //   element: <AddPaymentAccountDetails />,
      // },
      // { path: "/DespositVoucher", element: <DespositVoucher /> },
      // { path: "/PaymentVoucher", element: <PaymentVoucher /> },
      // { path: "/AddPaymentVoucher", element: <AddPaymentVoucher /> },
      // { path: "/AddDepositVoucher", element: <AddDespositVoucher /> },
      // { path: "/AddAccounts", element: <AddAccounts /> },
      // { path: "/AddTax", element: <AddTax /> },
      // { path: "/form-elements/slider", element: <ExSlider /> },
      // { path: "/form-elements/switch", element: <ExSwitch /> },
    ],
  },
];

export default ThemeRoutes;
